require("./configPanel.less");

import {resetDisplay, hide} from "../../utilities/selectorHelpers";
import html from "./html/configPanel.html";

function ConfigPanel(){
  const self = this;
  let element;

  self.init = function(){
    setElements();
  }


  self.getElement = function(){
    return element;
  }


  function setElements(){
    element = $(html);
  }

  self.attachToBody = function(){
    if (!gConfig.disableAll) {
      $('body').append(element);
    }
  }

  self.show = function(){
    resetDisplay(element);
  }
  self.hide = function(){
    hide(element);
  }
}

const gConfig = {};

ConfigPanel.gConfig = function(options={}) {
  gConfig.disableAll = options.disableAll;
};

export default ConfigPanel;


// WEBPACK FOOTER //
// ./src/pages/ConfigPanel/ConfigPanel.js